import { Button } from "@/newComponents/button/Button";

import { useAddAlbumWizardStore } from "../store/addAlbumWizardStore";

type AddAlbumWizardNavigationProps = {
  onNext?: () => void | Promise<void>;
  onPrevious?: () => void;
  nextLabel?: string;
  previousLabel?: string;
  nextDisabled?: boolean;
  isLoading?: boolean;
  hideNext?: boolean;
  hidePrevious?: boolean;
  isTunecore?: boolean;
};

export default function AddAlbumWizardNavigation({
  onNext,
  onPrevious,
  nextLabel = "Next",
  previousLabel = "Previous",
  nextDisabled = false,
  isLoading = false,
  hideNext = false,
  hidePrevious = false,
  isTunecore = false,
}: AddAlbumWizardNavigationProps) {
  const { currentStep, previousStep, nextStep } = useAddAlbumWizardStore();

  const handlePrevious = () => {
    if (isLoading) {
      return; // Don't proceed if loading
    }

    if (onPrevious) {
      onPrevious();
    }
    else {
      previousStep();
    }
  };

  const handleNext = () => {
    if (nextDisabled || isLoading) {
      return; // Don't proceed if disabled or loading
    }

    if (onNext) {
      void onNext();
    }
    else {
      nextStep();
    }
  };

  const isFirstStep = currentStep === "album-import";
  const isLastStep = currentStep === "summary-and-submit";

  return (
    <div className={`flex flex-col md:flex-row gap-4 w-full ${
      isFirstStep || hidePrevious
        ? "justify-end"
        : "justify-between"
    } mt-4
`}
    >
      {!isFirstStep && !hidePrevious && (
        <Button
          variant={isTunecore ? "secondary" : "darkSecondary"}
          label={previousLabel}
          onClick={handlePrevious}
          disabled={isLoading}
          className={isTunecore ? "border-tunecore-light-grey text-white hover:bg-tunecore-light-grey" : ""}
        />
      )}

      {!hideNext && (
        <Button
          onClick={handleNext}
          variant={isTunecore ? "primary" : "secondary"}
          label={isLastStep ? "Submit" : nextLabel}
          disabled={nextDisabled || isLoading}
        />
      )}
    </div>
  );
}
